import { MouseEvent, ReactNode } from 'react';

import VirtualizedCardGrid from 'src/common/components/virtualizedGrid/VirtualizedCardGrid';
import { IEnrichedParticipant } from 'src/interfaces/Participant';
import ParticipantCard from 'src/pages/Dashboard/Participants/components/ParticipantCard';

type VirtualizedParticipantGridProps = {
  participants: IEnrichedParticipant[];
  checkin?(id?: string, e?: MouseEvent<unknown>): void;
  register?(id?: string, e?: MouseEvent<unknown>): void;
  editRegistration?(id?: string, e?: MouseEvent<unknown>): void;
  deleteRegistration?(id?: string, e?: MouseEvent<unknown>): void;
  deleteParticipant(id: string, e?: MouseEvent<unknown>): void;
  editParticipant(id?: string, e?: MouseEvent<unknown>): void;
  transferParticipant?(id: string, e?: MouseEvent<unknown>): void;
  onDeleteCheckin?: (checkinId: string, e?: MouseEvent<unknown>) => void;
  onUpdatePrice?: (registrationId: string, price: number) => void;
  registrationIds?: Record<string, string>;
  tourRegisterAnchorParticipantId?: string;
  tourQrAnchorParticipantId?: string;
  adminTourMenuAnchorParticipantId?: string;
  adminTourRegisterAnchorParticipantId?: string;
  adminTourCheckinAnchorParticipantId?: string;
  /** Scrolls with the card grid (e.g. signup timeline). */
  header?: ReactNode;
};

const VirtualizedParticipantGrid = ({
  participants,
  checkin,
  register,
  editRegistration,
  deleteRegistration,
  deleteParticipant,
  editParticipant,
  transferParticipant,
  onDeleteCheckin,
  onUpdatePrice,
  registrationIds,
  tourRegisterAnchorParticipantId,
  tourQrAnchorParticipantId,
  adminTourMenuAnchorParticipantId,
  adminTourRegisterAnchorParticipantId,
  adminTourCheckinAnchorParticipantId,
  header,
}: VirtualizedParticipantGridProps) => (
  <VirtualizedCardGrid
    data-testid="virtualized-participant-grid"
    items={participants}
    getItemKey={p => p.id}
    chrome="standard"
    header={header}
    renderItem={(participant): ReactNode => (
      <ParticipantCard
        participant={participant}
        checkin={checkin}
        register={register}
        editRegistration={editRegistration}
        deleteRegistration={deleteRegistration}
        onDeleteCheckin={onDeleteCheckin}
        onUpdatePrice={onUpdatePrice}
        deleteParticipant={deleteParticipant}
        editParticipant={editParticipant}
        transferParticipant={transferParticipant}
        registrationId={registrationIds?.[participant.id]}
        isTourRegisterAnchor={participant.id === tourRegisterAnchorParticipantId}
        isTourQrAnchor={participant.id === tourQrAnchorParticipantId}
        isAdminTourMenuAnchor={participant.id === adminTourMenuAnchorParticipantId}
        isAdminTourRegisterAnchor={participant.id === adminTourRegisterAnchorParticipantId}
        isAdminTourCheckinAnchor={participant.id === adminTourCheckinAnchorParticipantId}
      />
    )}
  />
);

export default VirtualizedParticipantGrid;
